
export const colorEstadosChip = {
    'Incompleta': { isYellow: true },
    'Realizada': { isGreen: true }
};